import React, { Component} from "react";

import { 
  Layout, Page, Card,  SkeletonBodyText,EmptyState,Toast, Button, BlockStack,
  // List
} from "@shopify/polaris";

import { reqGetPricingPlan, reqPostUpdateUserPlan,reqPostExposureSummary } from '../../../../api';

import GetGoodReviews from '../../../../components/GetGoodReviews';

import "../index.css";

import intl from '../../../../i18n/intl';

import 'react-circular-progressbar/dist/styles.css';

class PricingClass extends Component {
  state = {
    loadingPage: false, // 加载页面

    // 提示弹窗
    showToast: false, // 提示弹窗是否显示
    showToastText: '', // 提示内容
    showToastIserror: false, // 是否为错误提示
    
    userPlan: 0,
    currentCount: 0,
    allPlans: [],

    freePlanLoading: false,
    starterPlanLoading: false,
    essentialPlanLoading: false,
    professionalPlanLoading: false,
    goodRating: false,
    getGoodReviewActive: false,
    carouselNumber: 0,
    carouselTextContent: <span>Limited to 10 places per day</span>
  };

  //进入页面调用接口
  componentDidMount() {    
    this.getPageData();
  }

  // 提示弹窗
  toggleToast = (showToastText, showToastIserror=false) => {
    this.setState(({ showToast }) => ({
      showToast: !showToast,
      showToastText: showToastText,
      showToastIserror: showToastIserror
    }));
  };
  
  // 获取价格套餐版本
  getPageData = async() =>{
    this.setState({
      loadingPage: true,
    });
    
    const params = {};
    const response = await reqGetPricingPlan(params)
    if (response.code === '200') {
      //更新状态
      this.setState({
        loadingPage: false,
        userPlan: response.data.currentPlan,
        currentCount: response.data.currentCount,
        allPlans: response.data.plans,
      });

      // 数据埋点统计
      this.handlePageStatistics('pricing');

    } else {
      this.toggleToast(response.msg);
      this.setState({
        loadingPage: false,
      });
    }

    // 启动轮播文字
    this.setTimedRotation();
  }

  updateUserPricingPlan = async(newLevel) =>{
    let userCurrentPlan = this.state.userPlan;
    if(userCurrentPlan !== newLevel){
      switch(newLevel){
        case 0:
          this.setState({freePlanLoading: true});
          break;
        case 1:
          this.setState({starterPlanLoading: true});
          break;
        case 2:
          this.setState({essentialPlanLoading: true});
          break;
        case 3:
          this.setState({professionalPlanLoading: true});
          break;
        default:
      }

      const params = {
        currentLevel: userCurrentPlan,
        newLevel: newLevel,
      };
      const response = await reqPostUpdateUserPlan(params);
  
      let stateParam = {};

      switch(newLevel){
        case 0:
          // this.setState({freePlanLoading: false});
          stateParam.freePlanLoading = false;
          break;
        case 1:
          // this.setState({starterPlanLoading: false});
          stateParam.starterPlanLoading = false;
          break;
        case 2:
          // this.setState({essentialPlanLoading: false});
          stateParam.essentialPlanLoading = false;
          break;
        case 3:
          // this.setState({professionalPlanLoading: false});
          stateParam.professionalPlanLoading = false;
          break;
        default:
      }

      if (response.code === '200') {
        // if (response.data !== '') {
        //   window.top.location.href = response.data;
        // }else{
        //   this.getPageData();
        // }

        /**
         * 当日前10名用户升级通过询问客服，超过10个，自动升级流程即可
         */
        if (response.data === 1) {
          // 更新用户最新的套餐
          stateParam.userPlan = newLevel;

          // 升级套餐，激活获取好评弹窗
          if(newLevel > 0){
            stateParam.getGoodReviewActive = true;
          }

          this.setState(stateParam);
          this.toggleToast(response.msg, false);

        } else {
          this.setState(stateParam);
          // 弹起客服弹窗
          this.handleActiveMessageBox('Hi, can you help me upgrade my plan to advanced plan for free?');
        }
      } else {
        this.setState(stateParam);
        this.toggleToast(response.msg);
      }
    }
  }

  // 评价弹窗关闭回调
  callBackReviewFunc = () => {
    this.setState({ getGoodReviewActive: false });
  }

  // 激活聊天弹窗
  handleActiveMessageBox = (text = '') => {
    let sendMsg = (text !== '') ? text : 'Welcome to Dropshipman';

    try {
      // 填充信息并激活对话弹窗
      // window.Intercom('showNewMessage', sendMsg);
      window.Willdesk.show();
      window.Willdesk.chat(sendMsg);
    } catch (error) {
      this.toggleToast('Intercom is not loaded. Please check your network and refresh the page.',true);
      console.info(error);
    }
  }

  // 定时轮播文本
  setTimedRotation = () => {
    setInterval(() => {
      let number = this.state.carouselNumber;
      if (number < 9) {
        number += 1;
      } else {
        number = 0;
      }
      this.setState({
        carouselNumber: number
      })
    },3000);
  }

  // 页面访问统计
  handlePageStatistics = async(type) => {
    try {
      const params = { type: type };
      await reqPostExposureSummary(params);

    } catch (error) {}
  }

  render() {
    // 提示弹窗
    const toastMarkup = this.state.showToast ? <Toast content={this.state.showToastText} onDismiss={()=>this.toggleToast('')} error={this.state.showToastIserror} duration={2200} /> : null;
    const {
      allPlans,userPlan,freePlanLoading,essentialPlanLoading,carouselNumber
      // currentCount
      // professionalPlanLoading,starterPlanLoading,
    } = this.state;

    const RightBase64 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAR60lEQVR4Xu2de5QkVX3Hf7+eqephFx8Ho8judvUuLtvVu3o0wUSPGk30qNGox+cUvgkSJBIkSIgiEhEBkSwbRBBxQZ4Cu7NJNNG8E/N+kgfRne7ejSxdvealeUvcrp6pX07VzODCzsxWV997p27Xd/++93t/9/Orz97q7uoeJvwDARBYkQCDDQiAwMoEIAiuDhBYhQAEweUBAhAE1wAI5COAEyQfN8wqCQEIUpJGY5v5CECQfNwwqyQEIEhJGo1t5iMAQfJxw6ySEIAgJWk0tpmPAATJxw2zSkIAgpSk0dhmPgIQJB83zCoJAQhSkkZjm/kIQJB83DCrJAQgSEkajW3mIwBB8nHDrJIQgCAlaTS2mY8ABMnHDbNKQgCClKTR2GY+AhAkHzfMKgkBCFKSRmOb+QhAkHzcMKskBCBISRqNbeYjAEHyccOskhCAICVpNLaZjwAEyccNs0pCAIKUpNHYZj4CECQfN8wqCQEIUpJGY5v5CECQfNwwqyQEIEhJGo1t5iMAQfJxw6ySEIAgJWk0tpmPAATJxw2zSkIAgpSk0dhmPgIQJB83zCoJAQhSkkZjm/kIQJB83DCrJAQgSEkajW3mIwBB8nHDLIMEDnru9tPCaNbgko8uBUHWgjrWzEyg47k/T0TTFaLptZAEgmRuFQaaJtCuu5eR0BXJuky0fy0kgSCmu471MhFo192PkNDHjx68FpJAkEztwiCTBDo198PCdNVya5qWBIKY7DzWOi6BludewkRXrzbQpCQQ5LgtwwBTBFqe+yEm+kSW9UxJAkGydANjtBNoe+7PEdEnh1nIhCQQZJiOYKwWAu169WISuTZPuG5JIEiermCOMgKdevUiEdk5SqBOSSDIKJ3B3JEIdGrVDwjLdSOFLE7WJQkEUdEdZAxNYLZWvbDCsmvoiatM0CEJBFHZIWRlItD2qhcQyfWZBg85SIg+1gyjy4ectuJwCKKKJHIyEWh71fcTyacyDR5ykGo5kuUhyJBNwPD8BFpe9XwmuSF/wsozmehjDYUnx9JKEERHt5B5DIFOvXqeiNyoA40QXdEMo4/qyIYgOqgi8zEEOjXnfcJ8kw4sOuXALZaOjiHzMQTaNedcYr5ZCxahj/u9KPm+iLZ/OEG0oUVwy3Pey8Sf1ULCgBw4QbR0DqEJgZbnnMPEt2ihYUgOCKKlewjt1J2zRXi3FhJCV/q96DIt2cuE4hbLFOmSrNOuO+8h4Vu1bNewHDhBtHSxvKHtmnMWMd+mhYDQVX4v+oiW7FVCcYKYJj6m67VqzpnMfLuW7TFd5XfNy4ETREs3yxfa8px3M/EdWna+hnJAEC0dLVdox3PeKcR36dg1M13d6EaX6sjOmolbrKykMO4YAm3PfQcR3a0DTRHkwAmio7MlyWzX3beT0D06titEn2iG0Yd1ZA+biRNkWGIYTwdq7ltjpnt1oEh+1aRREDlwgujo8JhnztbcMypM9+nYZtHkgCA6ujzGmW3PnSaiPTq2KETXNMPoEh3Zo2TiFmsUeiWa2/bctxDRXh1bZqJrGgWUAyeIjm6PYWbbc99MRDOatvZJP4w+pCl75FicICMjHO+AA3X3jbHQPk1fzy60HDhBxvvaHnl3nbr7BhKaEaKJkcOODbjWD6MPashVGokTRCnO8Qmbrbmvr3B6WzWpYVdWyIETREPnxyGyXau+Tlj2MZGjYT/WyAFBNHTf9siWV30tkyQnR1XDXn7BD6PkV9yt+YdbLGtapb/QA/Xqj8ciyQvyKQ2rWScHThANV4GtkZ169dUi6cmxTvUeRGhnsxddrDrXRB5OEBOUC75Gp1591aIc65WXKrTTt1QOnCDKrwb7Alu16iuZ09uqE5VXb7kcEET5FWFXYKtWfQVzelv1RNWVi8h1zd7gZ1Xnms7DLZZp4gVZb9arvryy8G7Vk1SXxCLXNcZADpwgqq8MS/I63tTLhOLkturJqksWll3N7uAi1blrlWf8BNnvuTt2hNH+tdpw2ddt16deShInJ8dJqlmMmxzGT5CW5yZ/+ectIhRs70VfV90g5K1O4ODmqR+Zj9OT4ymqWTHLrsYYnRxLfIydIIkcTLT0Nxxak0LTWyGJ6ut0xbzWpsmXVCYmZkTkqaoXFZZfbHYHH1CdW4Q8I4I8To5030zUimMKmoejrxUBxDjXMFubfHGFeYaIn6Z6n+Msh5FbrOXkOKpJbYop8A9H/6C6cchbINDxJl8UE+9j4pPVM5Hr/XBwofrc4iRqPUGOI8cShQ5PSNA4NHiwOFjGo5K2N/lCokrygvwU9Tsafzm0niAZ5VjoG9OBCkuw7eHB36tvZDkTW/XJF7CkcmxQT6AccmgTZCg5vte9g/MswY7u4O/UN7RciQc3O8+fjzl5t2qj+p3Lp/xw8DPqc4uZqPwWK6ccKR0h+kdhCbZ3B39bTFzFr2r/Jud5kxVOviZbU19tueRQfoKMIsdRzfyGkATNcPA36hs83omdmvOD6QtyJk/1ToXkhmY4uEB1btHzlJ0giuRY4vXQJMn0VkiS+fpp15znUvpWLm3OPCnzQLnBL6Ecyk4QxXIsvm6nh0Qk8HuDBzL3saQDW55zOlMqxxb1CMorhxJBDnru9phorxDtUN8cOsQiQaM3+GsN2WMRebDufP+8pC/IT1W9ISb5dCMcvF91rk15Sm6xOptdX+L0ZymfpWHzD3MsQePw4K80ZFsdeWCz8xyJ0xfkW1VvBHIsEFUiSBLU2ljdxhXZS0zPVt0sIupWYgm2HR78pYZsKyO/vtF59uREelt1muoNiMiNzd7gfNW5NuYpEyTZ/MFa9RnzLMlJ8gPKYQiF8YQE2x8e/IXybMsCW5vcZxFT8m7VNtWls8iNDcjxKFalgiSp7frUFpI4keS5qptHRD3hOGh25/5cQ7YVkbM195mLv3joqy4YchxLVLkgyRKzW6bqlflUkh9S3UQiOrwoyZ9pyC50ZPKGyDylPyTdVF2oiNzU7A1+WnWu7XlaBEmgfG3DCbXJifm9zPR8DZC+Ocnx9NbuXGkkOVB3m7LwQ9LK3y1kkZsakGPZy1SbIMlqnU0nbJTKfHKSvEC1JEz0TaE48MO5P1WdXbS8xXcJkxfkz1Rem8hn/N7gPOW5YxKoVZD0dqu+7pSKJJLIizQw+yemOGiEc3+iIbsQkem7gxPp71apfwud+TN+tw85Vum0dkHS260t60924rk9JPISDVfdP7PEQaM398castc0cnZT9bRK8rtVOt46Z77Z7/bft6YbtGBxI4Kkt1sb6Ptk0tlLxD+qgcu/VCQOtvXm/khD9ppELr5lnpwcz1FeAOTIjNSYIElFvU100iOVVJKXZa4w40Am+dc4lqB5eO4PM04p7LAD3tSpMaU/zaP+8yTIMVTfjQqSVHZoMz35SOzsZeKXD1VppsHyb7IgyR9kGl7AQYufIyVynK6+PP6sH/Z/Sn3u+CYaFyRBeXArPXE+cpN3t16pHK3It6gyEfjdI19Vnq058KEtU/VoPv3dKg0fskKOPO1bE0GSQvc/lU6cPMHdI0SvzlP46nP42/PMwY7ukd9Xn60ncf+pU97kXJx8zqH8w1UhvqUZ9s/VU/l4p66ZIAnWBzbQuidMppK8Rj1m/jYxJydJ4SVJP1R15mdY6HkaONziQ47cWNdUkMXXJFP92N1DRK/LvYuVJ/47UyVohEd+T0O2ksjkw9SY55MHDzU8ccCQY8Qurbkg6e3WdnInHnH3kNDrR9zPctP/o0KVYFt45Hc1ZI8U2a6t20A8l7wgV/6kgRB/rhn23ztSgZis7vsgo7L8KtHk02vuHmZ646hZy8z/z5g42B72f0dDdq7IQ5vXP70fz+0jkhfmClhlEhN/rgE5lGAtxAmytJPLiSqB5+5hojcr2d1jQ/5LhINmr//bGrKHinxoy/qTB/NzM0Lyw0NNzDBYiHc3w/45GYZiSAYChRJkqd6O594vREGG+ocd8t+LkvzWsBNVjX/wGSc+bWowSOR4sarMpRzIoZqowq/cqi6tU3fvFaG3qs4lov+hmAP/cP83NWSvGpk8bhM71X2s4Zk0Jt7dwMmhvKWFPEGWdtn23HuI6O3Kd030vwufk/R/Q0P2spGtjfQUnnCSP0Gg4Vk0vtUP+z9pai9lWqfQgiSNaHvuXUT0TtVNEaLvVJinGwYk2b+JTpqopHK8VPU+mPjWBuRQjfXRvMILklTa8tw7mOjdGih8h5mDRrf/6xqy08jk2bN+7OzT8YAmCd/m9/pn66oduQV+DfL45rTr7m0kdJaGpj1SYQ62dftfUZ39jVPpSXNzzozoeDATcqhu17J5VpwgS5V3vOpuIdHxP+b/CXHQDPtfVkW93aAn0Hfd5MHDV6jKfDRH6PN+L3qP8lwEHkPAKkGS6jte9RYh0fE+/3cXJfm1Ua+T5EHMiXXuDAn92KhZx8yHHMqRrhZonSALL9yrNxOJjqdTj5Bw4Pf6v5q3Cw+eTOurrpt8TfZVeTNWnMf0eb+Lk0M511UCrRQklaTm3ETMOr5T3SehwO9FXxq2Eb1NdMIjlfS2Sv0j/Ey3+91Ix2uwYbdZqvHWCpJ0qVVzPs3MOn7sLIqFgu296ItZr4ZDm2kqit3k+xzqH92HHFnboHyc1YIs3G451xOx8r98JESDitB0I4MkB7dSdT5yk6dyX6u6Q0J0RzOMfkJ1LvKyEbBekPQkqTu7WFjH3+seMFPQ6Ea/shLOB04n58RvpbdVyr/PwkR3NCBHtitZ06ixECR9d6vm7BTmizRwmqswBdu60S8/Pjt5RP+UevpulfLvsUAODZ3METk2gizcbrnXEtHFOTisOoWJ5mOmoNmNfmlpoBBV2jU3+SbgG1SvJ0R3NsPoTNW5yBuewFgJsijJNUT0weFRHHdGTESBH0b7hIg7Xvqa403HnTXkACa6swE5hqSmb/jYCZK+JvHcq5noEg3YJJGEiKZJw5e6hOiuZhjpeOZMA4pyRI6lIOlJUnOvJKZLbWkj5Chmp8ZWkEVJriCmy4qJ/ntVMdFdDZwchWzTWAuSvrvluR8VossLSX+hqLv9MHpXgesrdWljL0h6ktTdy0joigJ2GnIUsClHl1QKQRYluZSErixQP+7xw0j5NyULtL+xKKU0gizebl0iRFcXoHOQowBNyFJCqQRJTxLPTT4jST4rWat/X/DD6B1rtTjWHY5A6QRZuN2qXkwiyafupv9BDtPER1yvlIIkzFr16kUssnNEfsNMhxzD0CrI2NIKkr4mqVUvFJZd2nshdK/fi3T8vpf20su+QKkFWXhNUr2ASK7XdiFADm1oTQSXXpD0dsurns8kN6gGLkL3NXvR21TnIs8cAQiyyHq2Xj2vInKjKvTMdF+jCzlU8VyrHAhyFPl2zTmXmG8etRmQY1SCxZkPQR7Xi47nnJP80cu8LRKm+5vdSMev0uctCfNGIABBloHXqTtni/DuYbky0/0NyDEstkKPhyArtKddd85Kfhx6iO7t8cPojCHGY6gFBCDIKk1q1Zwzmfn2DH2EHBkg2TgEghynax3PeZcQ37nSMCba08DJYeO1n6lmCJIBU9tzk4cL715m6F4/jHT8LcUMVWGICQIQJCPlVt19Gwt94ajhkCMjO5uHQZAhujdbc8+oMN1HRDN+GCW/bIJ/Y04AggzZ4P2eO70jjPYOOQ3DLSUAQSxtHMo2QwCCmOGMVSwlAEEsbRzKNkMAgpjhjFUsJQBBLG0cyjZDAIKY4YxVLCUAQSxtHMo2QwCCmOGMVSwlAEEsbRzKNkMAgpjhjFUsJQBBLG0cyjZDAIKY4YxVLCUAQSxtHMo2QwCCmOGMVSwlAEEsbRzKNkMAgpjhjFUsJQBBLG0cyjZDAIKY4YxVLCUAQSxtHMo2QwCCmOGMVSwlAEEsbRzKNkMAgpjhjFUsJQBBLG0cyjZDAIKY4YxVLCUAQSxtHMo2QwCCmOGMVSwlAEEsbRzKNkMAgpjhjFUsJQBBLG0cyjZDAIKY4YxVLCUAQSxtHMo2QwCCmOGMVSwlAEEsbRzKNkMAgpjhjFUsJQBBLG0cyjZDAIKY4YxVLCUAQSxtHMo2QwCCmOGMVSwlAEEsbRzKNkMAgpjhjFUsJQBBLG0cyjZDAIKY4YxVLCXw/+5+twWRYKWVAAAAAElFTkSuQmCC';

    // 定时轮播数据
    const carouselData = [
      {
        name: 'w***n.myshopify.com',
      },
      {
        name: 'a***e.myshopify.com',
      },
      {
        name: 's***r.myshopify.com',
      },
      {
        name: 'c***e.myshopify.com',
      },
      {
        name: 'j***a.myshopify.com',
      },
      {
        name: 'r***p.myshopify.com',
      },
      {
        name: 'h***w.myshopify.com',
      },
      {
        name: 'b***m.myshopify.com',
      },
      {
        name: 'o***y.myshopify.com',
      },
      {
        name: 'a***g.myshopify.com',
      },
    ];

    // 加载页面
    const initSkeletonPage = (
      <Layout>
      <Layout.Section>
      <Card>
      <BlockStack gap={400}>
      <SkeletonBodyText lines={3}/>
      <SkeletonBodyText lines={3}/>
      <SkeletonBodyText lines={3}/>
      <SkeletonBodyText lines={3}/>
      <SkeletonBodyText lines={3}/>
      <SkeletonBodyText lines={3}/>
      <SkeletonBodyText lines={3}/>
      <SkeletonBodyText lines={3}/>
      <SkeletonBodyText lines={3}/>
      <SkeletonBodyText lines={3}/>
      <SkeletonBodyText lines={3}/>
      <SkeletonBodyText lines={3}/>
      <SkeletonBodyText lines={3}/>
      <SkeletonBodyText lines={3}/>
      </BlockStack>
      </Card>
    </Layout.Section>
      </Layout>
    );

    // 用户当前套餐
    const CurrentPlan = <Button fullWidth disabled>CURRENT PLAN</Button>;

    // 用户套餐产品更新数量
    // const userUpdateCount = (userPlan > 2) && (
    //   <div style={{color:'red'}}>
    //     {'Now your plan is ' + currentCount + '.'}
    //   </div>
    // )

    // 优化套餐版本信息
    const plansDetails = (allPlans.length > 0) ? (
      <div className="dropshipman_price">
        <div className="pricingContent">
          <div className="Polaris-Layout"> {/*卡片浮动*/}
            <div className="Polaris-Layout__Section Polaris-Layout__Section--oneThird"> {/*卡片上边距*/}
              <div className="Polaris-Card-2">
                <div className="Polaris-Card__Section">
                  <div style={{ width: "100%" }}></div>
                    <div className="bigspace"></div>
                    {/* <section className="centerAlign">
                      <div style={{paddingTop:'1rem'}}>
                          <img src="/website_score.png" role="presentation" alt="broken-links" />
                          <div className="Total-Number success-Text" style={{color:this.state.websiteScoreColor}}>{websiteScoreShow}</div>
                          <div className="Functional-Title" style={{opacity:'0',marginBottom:'0'}}>Site score</div>
                          {tempHeight}
                      </div>
                    </section> */}
                    <div className="bigbox" ></div>
                    <h2 className="Polaris-Heading" style={{ textAlign: "center",paddingBottom:"1rem" }} >
                        <div className="plan_name">Brief description</div>
                    </h2>
                    <div className="bigspace2"></div>
                    <div style={{  color: "#343434", fontSize: "12px", margin: "23px 0", textAlign: "center" }} >
                  </div>
                  <div className="pricingList">
                    {/* <table style={{borderCollapse:'collapse',width:'100%',whiteSpace:'nowrap'}}> */}
                    <table style={{borderCollapse:'collapse',width:'100%'}}>
                      <thead></thead>
                      <tbody>
                      <tr><td><div>Sourcing service & fulfillment with no MOQ </div></td></tr>
                        <tr><td><div>Bulk importing products with one click </div></td></tr>
                        <tr><td><div>Place unlimit orders to AliExpress </div></td></tr>
                        <tr><td><div>Order tracking number update </div></td></tr>
                        <tr><td><div>Tracking number update to PayPal </div></td></tr>
                        <tr><td><div>500 AliExpress products update </div></td></tr>
                        <tr><td><div>Shopify inventory address update & AliExpress product low Inventory update </div></td></tr>
                        <tr><td><div>AliExpress products price update with products cost + shipping fee </div></td></tr>
                        <tr><td><div>Aliexpress products update with notifications in App & Mail </div></td></tr>
                        <tr><td><div>Cashback affiliate Program</div></td></tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div className="Polaris-Layout__Section Polaris-Layout__Section--oneThird pricingCard">
              <div className="Polaris-Card">
                  <div className="Polaris-Card__Section">
                      <div className="bigspace"></div>
                      <h2 className="Polaris-Heading plan_name weight">{allPlans && allPlans[0] !== undefined && allPlans[0].name !== undefined ?allPlans[0].name:'Free'}</h2>
                      <div style={{textAlign:'center','marginTop':'20px',color:'#47c1bf'}}>
                          <span style={{fontSize:'60px'}}>{allPlans && allPlans[0] !== undefined && allPlans[0].price !== undefined ? allPlans[0].price:'$0.00'}</span>
                      </div>
                      <div style={{opacity: '.54',width: '100px',margin: 'auto',color: '#343434',fontSize: '12px',lineHeight: '24px',textAlign: 'center',fontStyle: 'italic'}}>Forever Free</div>
                      <div style={{color: '#343434',fontSize: '12px',margin: '30px 0',textAlign: 'center'}} >
                          {/* { PaidButton  } */}
                        {/* <div style={{margin:'1rem 1.6rem'}}>{freeButton}</div> */}
                        {/* <div style={{  color: "#343434", fontSize: "12px", margin: "3rem 0", textAlign: "center" }} > */}
                        <div className="pricing-button" >
                          {(userPlan === 0) ? (
                            CurrentPlan
                          ) : (
                            <Button onClick={()=>this.updateUserPricingPlan(0)} loading={freePlanLoading} fullWidth>DOWNGRADE</Button>
                          )}
                        </div>
                      </div>
                      <div className="pricingList">
                        <table style={{borderCollapse:'collapse',width:'100%',textAlign:'center'}}>
                          <thead></thead>
                          <tbody>
                            <tr><td className="td__Padding"><img src={RightBase64} alt="dropshiopman App" /></td></tr>
                            <tr><td className="td__Padding"><img src={RightBase64} alt="dropshiopman App" /></td></tr>
                            <tr><td className="td__Padding"><img src={RightBase64} alt="dropshiopman App" /></td></tr>
                            <tr><td className="td__Padding"><img src={RightBase64} alt="dropshiopman App" /></td></tr>
                            <tr><td className="td__Padding"><img src={RightBase64} alt="dropshiopman App" /></td></tr>
                            <tr><td></td></tr>
                            <tr><td className="bigtd"></td></tr>
                            <tr><td className="bigtd"></td></tr>
                            <tr><td className="bigtd"></td></tr>
                            <tr><td></td></tr>
                          </tbody>
                        </table>
                      </div>
                  </div>
              </div>
          </div>

          <div className="Polaris-Layout__Section Polaris-Layout__Section--oneThird pricingCard">
              {/* 定时滚动文本显示 */}
              <div className="carousel_text_box">
                <div className="animate_text">
                  <span>{carouselData[carouselNumber].name + ' has completed the upgrade'}</span>
                </div>
              </div>

              <div className="Polaris-Card">
                <div className="Polaris-Card__Section">
                  <div style={{ width: "100%" }}>
                    {/* <div style={{ float: "right", marginRight:'1.6rem' }}>{monthYearHtml}</div> */}
                  </div>
                  <div className="bigspace"></div>
                  <h2 className="Polaris-Heading plan_name weight">
                    {allPlans && allPlans[2] !== undefined && allPlans[2].name !== undefined ?allPlans[2].name:'Paid'}
                  </h2>
                  <div style={{ textAlign: "center", marginTop: "20px", color: "#47c1bf" }} >
                    <span style={{ fontSize: "30px",textDecoration:'line-through' }}>{allPlans && allPlans[2] !== undefined && allPlans[2].price !== undefined ? '$' + allPlans[2].price : '$0.00'}</span>
                    <span style={{ fontSize: "54px",color:'rgb(255 0 0)' }}>{" $0.00"}</span>
                  </div>
                  <div style={{ opacity: ".54", width: "100px", margin: "auto", color: "#343434", fontSize: "12px", lineHeight: "24px", textAlign: "center", fontStyle: "italic",paddingBottom:'3px' }} > / Month </div>
                  {/* <div style={{  color: "#343434", fontSize: "12px", margin: "3rem 0", textAlign: "center" }} > */}
                  <div className="pricing-button">
                    {(userPlan > 0) ? (
                      CurrentPlan
                    ) : (
                      <Button onClick={()=>this.updateUserPricingPlan(2)} loading={essentialPlanLoading} fullWidth variant="primary">UPGRADE</Button>
                    )}
                  </div>
                  <div className="pricingList pro">
                    <table style={{borderCollapse:'collapse',width:'100%',textAlign:'center'}}>
                      <thead></thead>
                      <tbody>
                        <tr><td><img src={RightBase64} alt="dropshipoman App"/></td></tr>
                        <tr><td><img src={RightBase64} alt="dropshipoman App" /></td></tr>
                        <tr><td><img src={RightBase64} alt="dropshipoman App" /></td></tr>
                        <tr><td><img src={RightBase64} alt="dropshipoman App" /></td></tr>
                        <tr><td><img src={RightBase64} alt="dropshipoman App" /></td></tr>
                        <tr><td><img src={RightBase64} alt="dropshipoman App" /></td></tr>
                        <tr><td className="bigtd"><img src={RightBase64} alt="dropshipoman App" /></td></tr>
                        <tr><td className="bigtd"><img src={RightBase64} alt="dropshipoman App" /></td></tr>
                        <tr><td className="bigtd"><img src={RightBase64} alt="dropshipoman App" /></td></tr>
                        <tr><td><img src={RightBase64} alt="dropshipoman App" /></td></tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="upgrade_contact">
          {'Need more info for AliExpress products update? '}
          <Button onClick={() => this.handleActiveMessageBox('Hi! I need more than 500 products limit for the update.')} variant='plain'>
            Please feel free to contact us. 
          </Button>
        </div>
      </div>
    ) :  (
      <Card sectioned>
        <EmptyState
          image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
        >
          <p>Opps... something wrong.</p>
        </EmptyState>
      </Card>
    );

    // 页面主内容
    const pageContent = this.state.loadingPage ? initSkeletonPage : (
      <Layout>
        <Layout.Section>
        <div className="space"></div>

          {plansDetails}

        <div className="bigspace"></div>
        </Layout.Section>
      </Layout>
    );

    return (
      <div>
        <Page 
          title={this.state.loadingPage ? '' : intl.get("Pricing")}
        >
          <div style={{"paddingTop":"1rem"}}></div>
          {/* 页面内容 */}
          {pageContent}

          {/* 获取好评弹窗 */}
          <GetGoodReviews
            heading_title = "Plan Upgrade Completed!"
            subtitle = "Would you mind letting us know what you think about us?"
            prompt_title = "Your valuable review will motivate us to improve."
            show={this.state.getGoodReviewActive}
            checkTime={false}
            callBack={this.callBackReviewFunc}
          />

          {/* 提示弹窗 */}
          {toastMarkup}
        </Page>
      </div>
    );

  }

}

export default PricingClass;